/* VFair */

import isSameDay from 'date-fns/isSameDay';

export enum VFairType {
    Standard = 0,
    SchoolAdmission = 1,
}

export enum VFairProfileRequirementLevel {
    Regular = 'regular',
    Minimum = 'minimum',
}

export interface VFair {
    id: string;
    title: string;
    body: string;
    image: string;
    fee: string;

    start: Date;
    end: Date;
    oneDayEvent: boolean;

    active: boolean;
    public: boolean;
    studentVisibility: boolean;
    personalInvites: boolean;

    vFairType: VFairType;
    visibility: number;
    profileRequirementLevel: VFairProfileRequirementLevel;
}

export interface VFairResponse {
    id: string;
    title: string;
    body: string;
    image: string;
    fee: string;

    start_date: string;
    end_date: string;

    active: boolean;
    public: boolean;
    personalInvites: boolean;
    studentVisibility: boolean;

    vFairType: VFairType;
    visibility: number;
    profileRequirementLevel: VFairProfileRequirementLevel;
}

export const transformVFair = (res: VFairResponse): VFair => {
    const start = new Date(res.start_date);
    const end = new Date(res.end_date);

    return {
        id: res.id,
        title: res.title,
        body: res.body,
        image: res.image,
        fee: res.fee,

        start,
        end,
        oneDayEvent: isSameDay(start, end),

        active: res.active,
        public: res.public,
        personalInvites: res.personalInvites,
        studentVisibility: res.studentVisibility,

        vFairType: res.vFairType,
        visibility: res.visibility,
        profileRequirementLevel: res.profileRequirementLevel,
    };
};

/* Other */

export interface VFairUser {
    userId: string;
    vfairId: string;
    interested: boolean;
    invited: boolean;
}
export interface VFairPavilion {
    id: string;
    vFairId: string;
    title: string;
    description: string | null;
    image: string | null;
    orderPriority: number;
    groupId: string;
}

export interface VFairPavilionGroup {
    id: string;
    vFairId: string;
    title: string;
    orderPriority: number;
    pavilions: VFairPavilion[];
}

export interface VFairSchoolConnection {
    vfairId: string;
    schoolId: number;
    exposed: boolean;
}

export interface VFairOrganization {
    vfairId: string;
    organizationId: number;
    status: number;
    prioritized: boolean;
    title: string;
    tagline: string;
    presentation: string;
    backgroundImage: string;
    logo: string;
    url: string;
    email: string;
    phone: string;
    twitter: string;
    facebook: string;
    linkedIn: string;
    instagram: string;
    youTube: string;
    vimeo: string;
    weChat: string;
}

/* FAQ */

export interface VFairOrganizationFAQ {
    id: string;

    question: string;
    answer: string;
    order: number;
}

/* Webinars */

export interface VFairWebinar {
    id: string;
    ownerOrganizationId: number;
    vFairId?: string;
    slug: string;
    status: number;
    title: string;
    description: string;
    startTime: string;
    endTime: string;
    backgroundImage: string;
    url: string;
    type: string;
}

export interface VFairActivity {
    userId: string;
    vFairRole: string;
    lastActive: string;
    firstName: string;
    lastName: string;
    avatar: string;
}

export type VFairWebinarShallow = Pick<
    VFairWebinar,
    'id' | 'vFairId' | 'ownerOrganizationId' | 'status' | 'title' | 'startTime' | 'endTime'
>;

// VFAIR HACK TYPES
export interface VFairHackConfig {
    pavillions: {
        external: {
            hostVFairId: string;
            hostVFairPavillionId: string;
            externalVFairId: string;
            externalVFairName: string;
            externalPlatformSubdomain: string;
        };
    };
    vfairs: {
        mygwork: {
            excludeSchools: number[];
        };
    };
    redirectUrl?: string;
}
// END VFAIR HACK TYPES
